import _ from 'lodash'
import Slider from 'react-slider'
import {IMixerChannel} from '.'
import {defaultCutStepSize} from '../../semantic-filtering/const'

export interface ICutControlProps {
  isInteger?: boolean
  disabled?: boolean
  descriptor: IMixerChannel['descriptor']
  value: IMixerChannel['value']
  cutStepSize?: number
  onChanged: (
    args: Partial<{
      descriptor: Partial<IMixerChannel['descriptor']>
      data: Partial<IMixerChannel['value']>
    }>
  ) => void
}

export function CutControl(props: ICutControlProps) {
  const {isInteger, disabled, descriptor, value, cutStepSize, onChanged} = {
    cutStepSize: props.isInteger ? 1 : props.cutStepSize || defaultCutStepSize,
    ...props,
  }

  const {range} = descriptor

  const {cut} = value

  function handleNudgeCutMin(value: number) {
    const newVal = _.clamp((cut?.min || 0) + value, range.min, cut?.max || range.min)
    onChanged({
      data: {
        cut: {
          min: Math.abs(newVal) >= cutStepSize ? newVal : 0,
          max: cut?.max || range.min,
        },
      },
    })
  }

  function handleNudgeCutMax(value: number) {
    const newVal = _.clamp((cut?.max || 0) + value, cut?.min || range.min, range.max)
    onChanged({
      data: {
        cut: {
          min: cut?.min !== undefined ? cut.min : range.min,
          max: Math.abs(newVal) >= cutStepSize ? newVal : 0,
        },
      },
    })
  }

  return (
    <div className='controls cut'>
      <div className='label'>
        cut: {cut ? cut.min.toFixed(isInteger ? 0 : 3) : '-'} -&gt;{' '}
        {cut ? cut.max.toFixed(isInteger ? 0 : 3) : '-'}
      </div>
      <div className='slider-wrap'>
        <div
          className='nudge'
          onClick={() => handleNudgeCutMin(-cutStepSize)}
        >
          -
        </div>
        <div
          className='nudge'
          onClick={() => handleNudgeCutMin(cutStepSize)}
        >
          +
        </div>
        {/* <div className='zero'>
                <Popup
                    size='tiny'
                    content='set cut min to 0'
                    trigger={<div className='nudge' onClick={() => handleZeroCutMin()}>
                        <SiZeromq />
                    </div>}
                />
                <div className='divider' />
                <Popup
                    size='tiny'
                    content='set cut max to 0'
                    trigger={<div className='nudge' onClick={() => handleZeroCutMax()}>
                        <SiZeromq />
                    </div>}
                />
            </div> */}
        <Slider
          min={range ? range.min : 0}
          max={range ? range.max : 1}
          step={cutStepSize}
          value={cut ? [cut.min, cut.max] : [0, 1]}
          onAfterChange={([min, max]) => onChanged({data: {cut: {min, max}}})}
          disabled={disabled}
        />
        <div
          className='nudge'
          onClick={() => handleNudgeCutMax(-cutStepSize)}
        >
          -
        </div>
        <div
          className='nudge'
          onClick={() => handleNudgeCutMax(cutStepSize)}
        >
          +
        </div>
      </div>
    </div>
  )
}
